// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/dashboard/app',
    icon: icon('ic_panel'),
  },
  {
    title: 'users',
    path: '/dashboard/users',
    icon: icon('ic_user'),
  },
  {
    title: 'approve orders',
    path: '/dashboard/orders/approve',
    icon: icon('ic_order'),
  },
  {
    title: 'feature orders',
    path: '/dashboard/orders/feature',
    icon: icon('ic_order'),
  }
];

export default navConfig;
